var wW;
var wH;
var wS = 1;
var wB;

$(function () {
  wW = window.innerWidth;
  wH = window.innerHeight;
  wS = $(window).scrollTop();
  wB = wS + wH;
  var bodyStopWs;
  scrollTrigger();
  ua();
});

$(window).on("load", function () {
  wW = window.innerWidth;
  wH = window.innerHeight;
  wS = $(window).scrollTop();
  wB = wS + wH;
});


$(window).on("scroll", function () {
  wS = $(window).scrollTop();
  wB = wS + wH;
});

$(window).resize(function () {
  wW = window.innerWidth;
  wH = window.innerHeight;
  wB = wS + wH;
});

function ua(){
  var agent = window.navigator.userAgent.toLowerCase();

  if (agent.match(/(msie|MSIE)/) || agent.match(/(T|t)rident/)) {
    var isIE = true;
    $("body").addClass("ie");
  } else {
    var isIE = false;
  }
  if (agent.indexOf("edge") !== -1) {
    var isEdge = true;
    $("body").addClass("isEdge");
  } else {
    var isEdge = false;
  }
  if(agent.indexOf("iphone") !== -1 || agent.indexOf("ipad") !== -1) {
    var iOSmobile = true;
    $("body").addClass("iOSmobile");
    safariMetaSafeArea();
  } else {
    var iOSmobile = false;
  }
}

function scrollTrigger(){
  const target = document.querySelectorAll('.scroll-trigger')
  const targetArray = Array.prototype.slice.call(target);

  const options = {
      root: null,
      rootMargin: '0px 0px -150px',
      threshold: 0
  };

  const observer = new IntersectionObserver(callback, options)
  targetArray.forEach((tgt) => {
    observer.observe(tgt)
  });

  function callback(entries) {
    entries.forEach(function(entry, i) {
      const target = entry.target;
      if (entry.isIntersecting && !target.classList.contains('scroll-active')) {
        const delay = i * 100
        setTimeout(function(){
          target.classList.add('scroll-active');
        },delay);
      }
    });
  };
}

function bodyFixed(){
  bodyStopWs = wS;
  $("body").css({top:-1*bodyStopWs})
  $("body").addClass("is-stop");
}

function bodyNotFixed(){
  $("body").removeClass("is-stop");
  $("body").css("top","");
  window.scrollTo(0, bodyStopWs)
}

function safariMetaSafeArea(){
  const head = document.head;
  head.insertAdjacentHTML('beforeEnd', '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0,viewport-fit=cover">');
}


const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
 
window.addEventListener('load', setVh);
window.addEventListener('resize', setVh);
window.addEventListener('scroll', setVh);

